<template>
  <div
    class="landing-view"
    :style="'background-image: url(media/auth/auth-bg.png)'"
  >
    <section class="info">
      <h1 class="section-title">Join Prosper Africa's deal room</h1>
      <p>
        The U.S. Government's Prosper Africa Initiative helps U.S. businesses
        and investors pursue promising trade and investment opportunities in
        Africa. This Virtual Deal Room allows enterprises, investors, and
        counterparties to engage with curated trade and investment opportunities
        between the U.S and Africa. You can find information about
        <a href="https://www.prosperafrica.gov/toolkit/" target="_blank"
          >U.S.&nbsp;Government services and resources</a
        >
        that can support successful private sector transactions.
      </p>
    </section>

    <section class="benefits-section mt-20">
      <div class="benefit-wrap">
        <h5 class="benefit-label" style="--color: #307597">
          For African companies <b>seeking funding:</b>
        </h5>
        <div class="benefits-card card">
          <div class="als-benefit">
            <img src="media/events/als/benefit.svg" alt="Als benefit" />
            <div class="benefit-caption">
              <p>Upload deal information in the portal</p>
            </div>
          </div>
          <div class="separator separator-dashed border-primary my-3"></div>
          <div class="als-benefit">
            <img src="media/events/als/benefit.svg" alt="Als benefit" />
            <div class="benefit-caption">
              <p>Get referred to specialized support for deal preparation</p>
            </div>
          </div>
          <div class="separator separator-dashed border-primary my-3"></div>
          <div class="als-benefit">
            <img src="media/events/als/benefit.svg" alt="Als benefit" />
            <div class="benefit-caption">
              <p>
                Connect with potential investors who express interest in your
                deal
              </p>
            </div>
          </div>

          <router-link
            :to="{ name: 'sign-up' }"
            class="btn btn-primary mt-10"
            style="background: #307597"
            @click="setPrimaryRole('investee')"
          >
            Apply to Deal Room
          </router-link>
        </div>
      </div>

      <div class="benefit-wrap mx-5">
        <h5 class="benefit-label" style="--color: #c8355d">
          For investors looking <b>to invest in Africa:</b>
        </h5>
        <div class="benefits-card card" style="border-top: 20px solid #c8355d">
          <div class="als-benefit">
            <img src="media/events/als/benefit.svg" alt="Als benefit" />
            <div class="benefit-caption">
              <p>
                Screen for deals aligned with your investment interests, get
                notified of new deals that meet your criteria
              </p>
            </div>
          </div>
          <div class="separator separator-dashed border-primary my-3"></div>
          <div class="als-benefit">
            <img src="media/events/als/benefit.svg" alt="Als benefit" />
            <div class="benefit-caption">
              <p>
                Receive support from qualified transaction advisors to help you
                deploy capital in Africa
              </p>
            </div>
          </div>
          <div class="separator separator-dashed border-primary my-3"></div>
          <div class="als-benefit">
            <img src="media/events/als/benefit.svg" alt="Als benefit" />
            <div class="benefit-caption">
              <p>Review market and sector studies</p>
            </div>
          </div>

          <router-link
            :to="{ name: 'sign-up' }"
            class="btn btn-primary mt-10"
            style="background: #c8355d"
            @click="setPrimaryRole('investor')"
          >
            Review deals
          </router-link>
        </div>
      </div>

      <div class="benefit-wrap">
        <h5 class="benefit-label" style="--color: #dca93d">
          For intermediaries looking <b>to support deal making:</b>
        </h5>
        <div class="benefits-card card" style="border-top: 20px solid #dca93d">
          <div class="als-benefit">
            <img src="media/events/als/benefit.svg" alt="Als benefit" />
            <div class="benefit-caption">
              <p>Support deal making, help investees to get deals published</p>
            </div>
          </div>
          <div class="separator separator-dashed border-primary my-3"></div>
          <div class="als-benefit">
            <img src="media/events/als/benefit.svg" alt="Als benefit" />
            <div class="benefit-caption">
              <p>Use power of community: connect with other intermediaries</p>
            </div>
          </div>
          <div class="separator separator-dashed border-primary my-3"></div>
          <div class="als-benefit">
            <img src="media/events/als/benefit.svg" alt="Als benefit" />
            <div class="benefit-caption">
              <p>Get insights, acquaintance and useful information</p>
            </div>
          </div>

          <router-link
            :to="{ name: 'sign-up' }"
            class="btn btn-primary mt-10"
            style="background: #dca93d"
            @click="setPrimaryRole('intermediary')"
          >
            Support deal making
          </router-link>
        </div>
      </div>
    </section>

    <h5 class="privacy-disclaimer">
      <inline-svg src="media/icons/custom/privacy.svg" />
      Your information is treated in confidence throughout the Prosper Africa
      deal support process
    </h5>

    <section class="tabs-section">
      <h1 class="section-title text-center">Why sign up?</h1>
      <landing-tabs />
    </section>
  </div>
</template>

<script>
import LandingTabs from "@/custom-components/landing/landing-tabs.vue";

export default {
  name: "LandingView",
  components: {
    LandingTabs,
  },
  methods: {
    setPrimaryRole(role) {
      this.$store.dispatch("account/setPrimaryRole", role);
    },
  },
};
</script>

<style lang="scss" scoped>
.landing-view {
  color: #fff;
  padding-top: 150px;
  background-color: rgba(14, 49, 103, 0.9);
}
.section-title {
  color: #fff;
  font-size: 50px;
  font-weight: 600;
  margin-bottom: 25px;
}
.info {
  text-align: center;
  p {
    max-width: 850px;
    margin: 0 auto;
    font-size: 18px;
    font-weight: 500;
    font-family: Poppins;
  }
  a {
    color: #00a3ff;
  }
}
.benefits-section {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.benefits-card {
  background: #fff;
  border-top: 20px solid #307597;
  border-radius: 12px;
  padding: 20px;
  width: 450px;
  color: #0e3167;
  .btn {
    color: #fff;
    font-family: "Poppins";
    font-weight: 500;
    font-size: 16px;
  }
}

.als-benefit {
  display: flex;
  align-items: center;
  img {
    margin-right: 15px;
  }
  .benefit-caption {
    p {
      margin-bottom: 0px;
      align-self: center;
      font-family: "Poppins";
      font-weight: 400;
      font-size: 16px;
    }
  }
}
.separator {
  margin-left: 55px;
  max-width: 750px;
}
.tabs-section {
  margin-top: 100px;
  margin-left: auto;
  margin-right: auto;
  max-width: 1400px;
  .section-title {
    margin-bottom: 50px;
  }
}

.benefit-label {
  margin-bottom: 15px;

  font-weight: 400;
  font-size: 18px;
  color: #ffffff;

  b {
    font-weight: 600;
    border-bottom: 2px solid var(--color);
  }
}
.privacy-disclaimer {
  text-align: center;
  color: #c8355d;
  font-size: 18px;
  font-weight: 600;
  margin-top: 30px;
  svg {
    vertical-align: bottom;
    margin-right: 5px;
  }
}
</style>
